import React from "react";
import * as helpers from '../helpers.mjs';
import {PubSub} from '../weave/helpers.mjs';
import { getAuthorityIdFromCookie, getOrderingGridConfig } from './orderingGridStorage.mjs';

import { Tooltip } from 'react-tooltip'

const Header = ({fromBookshelf,fromBasketBuilder,title,author,binding,label,patterns,applyPattern,cycles,applyCycle}) => (
    <div>
        {!fromBookshelf && (!fromBasketBuilder || fromBasketBuilder.length == 0) && <div>
            <table className="productDetailsTable">
                <thead>
                    <tr>
                        <th className="title">Title</th>
                        <th className="author">Author</th>
                        <th className="binding">Binding</th>
                        <th className="dewey">Dewey</th>
                    </tr>
                </thead>
                <tbody>
                    <tr className="productInfo">
                        <td>{helpers.decodeHTML(`${title}`)}</td>
                        <td>{author}</td>
                        <td>{binding}</td>
                        <td>
                            <input className="form-input" type="text" name="addToBasket[label]" value={label} title="Spine label" onChange={(e) => {PubSub.pub("updateLabel", e.target.value)}} />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>}
        <div>
            <table className="codesTable">
                <tbody>
                    <tr>
                       {patterns && <>
                       <td className="title">Apply pattern:</td>
                        <td className="select">
                            <select onChange={applyPattern} className="form-select applyPatternSelect">
                                <option value="none">Select pattern...</option>
                                {patterns.map((p, i) => 
                                    <option key={p.id} value={i}>{p.name}</option>
                                )}
                            </select>
                        </td>
                        </>}
                        {cycles && <>
                            <td className="title">Apply cycle:</td>
                            <td className="select">
                                <select onChange={applyCycle} className="form-select applyCycleSelect">
                                    <option value="none">Select cycle...</option>
                                    {cycles.map((c, i) => 
                                        <option key={c.id} value={i} data-quantity={c.quantity}>{c.name}</option>
                                    )}
                                </select>
                            </td>
                        </>}
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
);

class QuantityInput extends React.Component {
    changeQuantity(e) {
        if (!e.target.validity.valid) {
            return false;
        }
        // var v = e.target.value;
        // if (e.target.value == "") {
            // v = 0;
        // }
        // var diff = this.props.value - v;
        
        PubSub.pub("updateBasketBranch", this.props.branch, "quantity", e.target.value != "" ? e.target.value : "");
        // PubSub.pub("updateBasketBranchAll", this.props.branch, "branchTotalItems", this.props.branchItems - diff, this.props.basketId);
    }

    // setToZero() {
    //     PubSub.pub("updateBasketBranch", this.props.branch, "quantity", 0);
    // }

    removeQuantity() {
        PubSub.pub("updateBasketBranch", this.props.branch, "quantity", "");
    }

    propagate() {
        this.props.propagate("quantity", this.props.value, this.props.branch);
    }

    render() {
        var classes = "fa fa-arrow-down copyIcon";

        var maxQty = 999;

        var trashClasses = "fa fa-trash";
        var hideTrashButton = (this.props.value == 0);
        if (hideTrashButton) {
            trashClasses += " invisible";
        }

        return (
            <td className="center">
                <i className={classes} onClick={this.propagate.bind(this)} title="Click to set this as the quantity for all branches below this one"></i>
                <input type="number" pattern="[0-9]*" inputMode="numeric" min="0" max={maxQty} className="form-input bbQty" onChange={this.changeQuantity.bind(this)} name={this.props.name} placeholder="0" value={this.props.value} />
                {!hideTrashButton ? <i className={trashClasses} title="Remove quantity" onClick={this.removeQuantity.bind(this)}></i> : <i className={trashClasses}></i>}
            </td>
        );
    }
}
 
class TableRow extends React.Component {
    changeOption(e) {
        const code = e.target.dataset.code;
        PubSub.pub("updateBasketBranch", this.props.basketBranch.branchId, code, e.target.value);
    }

    incrementTier() {
        const tier = this.props.basketBranch.tier;
        this.props.incrementTier(tier);
    }

    // propagate(e) {
    //     const code = e.target.dataset.code ? e.target.dataset.code : "quantity";
        
    //     this.props.propagate(code, e.target.value);
    // }

    render() {
        const basketBranch = this.props.basketBranch;
        const name = `addToBasket[basketBranch][${basketBranch.branchId}][quantity]`;
        const rs = basketBranch.tierCount > 0 ? basketBranch.tierCount : 1;
        const scname = `addToBasket[basketBranch][${basketBranch.branchId}][stockCategory]`;
        // const oid = "orderTracking_" + basketBranch.branchId;
        return (
            <tr className={basketBranch.tierClass}>
                {this.props.isNotFromBookshelfOrBasketBuilder && <td className="center orderTrack">{basketBranch.alreadyInBasket !== null ? Number(basketBranch.alreadyInBasket) : ''}</td>}
                {this.props.isNotFromBookshelfOrBasketBuilder && <td className="center orderTrack">{basketBranch.altAlreadyInBasket !== null ? Number(basketBranch.altAlreadyInBasket) : ''}</td>}
                {this.props.isNotFromBookshelfOrBasketBuilder && <td className="center orderTrack">{basketBranch.alreadyOrdered !== null ? Number(basketBranch.alreadyOrdered) : ''}</td>}
                {this.props.isNotFromBookshelfOrBasketBuilder && <td className="center orderTrack">{basketBranch.altAlreadyOrdered !== null ? Number(basketBranch.altAlreadyOrdered) : ''}</td>}
                
                {(basketBranch.switchedTier || basketBranch.tierCount == 0) && <td rowSpan={rs} className={`tierRow ${basketBranch.tierName != "" ? "branchTierName" : ""}`}>{basketBranch.tierName} {basketBranch.switchedTier == 1 && <i className="fa fa-plus addToTier copyIcon" onClick={this.incrementTier.bind(this)} title="Click to add 1 to all branches in this tier"></i>}</td>}
                {this.props.hasAreas && <td>{basketBranch.areaName}</td>}
                <td title={basketBranch.branchName}>{basketBranch.branchCode}</td>
                <td title={basketBranch.tierName && "Tier: "+basketBranch.tierName}>{basketBranch.branchName}</td>
                {this.props.isNotFromBookshelfOrBasketBuilder && <td className="right">£{basketBranch.price}</td>}
                {this.props.isNotFromBookshelfOrBasketBuilder && <td className="right">£{basketBranch.servicing}</td>}
                <QuantityInput value={basketBranch.quantity} name={name} branch={basketBranch.branchId} index={this.props.index} propagate={this.props.propagate} branchItems={basketBranch.branchTotalItems} basketId={this.props.basketId} />
                <td className="center">{basketBranch.branchTotalItems !== null ? Number(basketBranch.branchTotalItems) : ''}</td>
                <td className="right">{basketBranch.branchTotal !== null ? helpers.currency(basketBranch.branchTotal) : ''}</td>
                
                {(this.props.ediRequired == 1 || this.props.ediOverride == 1) && this.props.ediOptions.map(edi => {
                    const sname = `addToBasket[basketBranch][${basketBranch.branchId}][options][${edi.aoEdiId}]`;
                    // const options = this.props.basketOptions.filter(opt => opt.edi === edi.aoEdiId).map(opt => ({
                    //     value: opt.edi,
                    //     label: opt.code
                    // }));
                    const codes = this.props.basketOptions.filter(opt => opt.edi === edi.aoEdiId); //.filter(opt => (opt.stockCohort === null || opt.stockCohort === this.props.basketStockCohort))
                    if (codes.length === 0) {
                        return null;
                    }
                    const code = codes[0].ediCode;
                    const selected = basketBranch[code] ? basketBranch[code] : "";

                    return (<td key={edi.aoEdiId}>
                        <select data-tooltip-id="orderingGridTooltip" data-tooltip-content={this.props.basketOptions.find(o => o.code === selected && o.edi === edi.aoEdiId)?.name} onChange={this.changeOption.bind(this)} data-code={code} className="form-select" value={selected} name={sname}>
                            {(edi.aoNeedOnAdd != "1" || selected === "") && <option key="none" value="" title={this.props.basketOptions.find(o => o.edi === edi.aoEdiId && o.code === "")?.name || "None"}>{this.props.basketOptions.find(o => o.edi === edi.aoEdiId && o.code === "")?.name || "None"}</option>}
                            {this.props.basketOptions.filter(opt => opt.edi === edi.aoEdiId && opt.code != "" && (opt.stockCohort === null || opt.stockCohort === this.props.basketStockCohort)).map(opt => (
                                <option key={opt.id} value={opt.code} title={opt.name}>{opt.code}</option>
                            ))}
                        </select>

                        <i className="fa fa-arrow-down copyIcon copyOption" title="Click to set this option for all branches below this one" onClick={e => {this.props.propagate(code, basketBranch[code], basketBranch.branchId)}}></i>
                    </td>);
                })}

                {this.props.showStockCategories &&
                    <td>
                        <select className="form-select" data-code="stockCategory" name={scname} onChange={this.changeOption.bind(this)} title="Choose a stock category" value={basketBranch.stockCategory} required>
                            <option value="">Choose a stock category... </option>
                            {this.props.stockCategories.map(stockCategory => 
                                <option key={stockCategory.id} value={stockCategory.id}>{stockCategory.name}</option>
                            )}
                        </select>

                        <i className="fa fa-arrow-down copyIcon copyOption" title="Click to set this option for all branches below this one" onClick={e => {this.props.propagate("stockCategory", basketBranch.stockCategory, basketBranch.branchId)}}></i>
                    </td>
                }
            </tr>
        );
    }
}

const Totals = ({rs, isNotFromBookshelfOrBasketBuilder, data, getItemServicingTotal}) => {
    const totalCost = data.data.reduce((prev, cur) => prev + Number(cur.price)*Number(cur.quantity), 0);
    const totalItems = data.data.reduce((prev, cur) => prev + Number(cur.quantity), 0);
    const totalServicing = getItemServicingTotal(data.basketId, data.prId);

    return <tfoot className="totals">
        <tr>
            <td colSpan={rs} className="right"><strong>Totals</strong></td>
            {isNotFromBookshelfOrBasketBuilder && <td className="right totalCost">{helpers.currency(totalCost)}</td>}
            {isNotFromBookshelfOrBasketBuilder && <td className="right">{helpers.currency(totalServicing)}</td>}
            <td className="center">{totalItems}</td>
            <td colSpan="2"></td>
        </tr>
    </tfoot>
}

class OrderingGrid extends React.Component {
    constructor(props) {
        super(props);
        // the grid can be shown (double-click, or a prefill fallback) while a config is
        // already saved for this authority — reflect that it's active rather than defaulting
        // to unchecked, which would otherwise delete the saved config on submit unless the
        // user manually ticks then unticks it to cancel
        const authorityId = getAuthorityIdFromCookie();
        const hasSavedConfig = !!(props.orderingGridMemoryEnabled && getOrderingGridConfig(authorityId));
        this.state = {
            rememberChoices: hasSavedConfig
        };
    }

    applyPattern(e) {
        const i = e.target.value;
        const pattern = this.props.data.patternCodes[i];
        
        for (var branch in pattern) {
            PubSub.pub("addToBasketBranch", branch, "quantity", pattern[branch]);
        }
        document.querySelector(".applyPatternSelect").selectedIndex = 0;
    }

    applyCycle(e) {
        
        const i = e.target.value;
        const branches = Object.values(this.props.data.cycleCodes[i]);
        const cycleCode= this.props.data.cycles[i];
        let position = cycleCode.position; //6
        const quantity = cycleCode.quantity; //6
    
        let branchesToAdd = [];

        while(branchesToAdd.length < quantity){
            if(position == branches.length) position = 0;            
            position = position % branches.length;
            branchesToAdd.push(branches[position]);
            position++; 
        }

        //reduce branchesToAdd array into branch:qty
        branchesToAdd = branchesToAdd.reduce(function (b, q) {
            return b[q] ? ++b[q] : b[q] = 1, b
          }, {});
    
       
        for(const branch in branchesToAdd){
            PubSub.pub("updateBasketBranch", branch, "quantity", branchesToAdd[branch]);
        }
        
        fetch("/cycleCode/updatePosition/"+cycleCode.id,{
            method: "POST", 
            headers:{
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                "position": position
            })
        });

        document.querySelector(".applyCycleSelect").selectedIndex = 0;
    }

    incrementTier(tier) {
        this.props.data.data.filter(b => b.tier === tier).forEach(b => {
            var q = Number(b.quantity);
            PubSub.pub("updateBasketBranch", b.branchId, "quantity", q+1);
        });
    }

    propagate(field, value, selectedBranchId) {
        var allBranches = this.props.data.data;
        var startingBranch = allBranches.findIndex(b => b.branchId == selectedBranchId);
        allBranches.slice(startingBranch, allBranches.length).forEach(d => {
            PubSub.pub("updateBasketBranch", d.branchId, field, value);
        });
    }

    toggleRememberChoices(e) {
        this.setState({rememberChoices: e.target.checked});
    }

    render() { 
        const data = this.props.data;
        
        var rs = (this.props.fromBookshelf || (this.props.basketBuilderData && this.props.basketBuilderData.length > 0)) ? 3 : 7;

        const hasAreas = data.data ? data.data.some(b => b.areaName != "") : false;

        if (hasAreas) {
            rs++;
        }

        const noBookshelfId = (!this.props.fromBookshelf); // Bookshelf ID equals 0
        const noBasketBuilderData = (this.props.basketBuilderData && this.props.basketBuilderData.length == 0); // Build basket data is not populated
        const isNotFromBookshelfOrBasketBuilder = (noBookshelfId && noBasketBuilderData);

        return (
            <form id="orderingGrid" className="form-horizontal" method="post">
                <Tooltip id="orderingGridTooltip" />
                <Header fromBookshelf={this.props.fromBookshelf} fromBasketBuilder={this.props.basketBuilderData} label={data.label} title={data.title} author={data.author} binding={data.binding} patterns={data.patterns} applyPattern={this.applyPattern.bind(this)} cycles={data.cycles} applyCycle={this.applyCycle.bind(this)} />
                 {this.props.orderingGridMemoryEnabled && isNotFromBookshelfOrBasketBuilder && (
                    <div className="orderingGridMemoryToggle">
                        <label>
                            <input type="checkbox" name="rememberChoices" checked={this.state.rememberChoices} onChange={this.toggleRememberChoices.bind(this)}/>
                            &nbsp;Save my choices and automatically apply them in the future
                        </label>
                        {this.state.rememberChoices && (
                            <p style={{color:"#DA1E63"}}>
                                <i className="fa fa-exclamation"></i>&nbsp;
                                <span>The same options will now be applied to all items you add to any basket. Click on the ADD TO BASKET button a second time
                                    to vary anything or to disable this going forward
                                </span>
                            </p>
                        )}
                    </div>
                 )}
                <table className="orderingGridTable">
                    <thead>
                        <tr>
                            {isNotFromBookshelfOrBasketBuilder && <th className="center basket" title="Already in baskets"><i className="fas fa-shopping-basket"></i></th>}
                            {isNotFromBookshelfOrBasketBuilder && <th className="center altEditions" title="Alternative editions in baskets"><i className="fas fa-shopping-basket"></i></th>}
                            {isNotFromBookshelfOrBasketBuilder && <th className="center ordered" title="Already ordered"><i className="fas fa-calendar-check"></i></th>}
                            {isNotFromBookshelfOrBasketBuilder && <th className="center altEditions" title="Alternative editions ordered"><i className="fas fa-calendar-check"></i></th>}
                            <th className="tier">Tier</th>
                            {hasAreas && <th className="area">Area</th>}
                            <th colSpan="2" className="branch">Branch</th>
                            {isNotFromBookshelfOrBasketBuilder && <th className="right unitPrice">Unit price</th>}
                            {isNotFromBookshelfOrBasketBuilder && <th className="right servicing">Servicing</th>}
                            <th className="center qty">Qty</th>
                            <th className="center branchTotals" colSpan="2">Branch totals</th>
                            {(data.ediRequired == 1 || data.ediOverride == 1) && data.ediOptions.map(edi =>
                                <th className={`${helpers.toCamelCaseString(edi.aoName)} edi`} key={edi.aoId}>{edi.aoName}</th>
                            )}
                            {data.showStockCategories && data.internal == 0 && <th className="supplierSelection">Supplier selection budget category</th>}
                            {data.showStockCategories && data.internal == 1 && <th className="stockCategory">Weave stock category</th>}
                        </tr>
                    </thead>
                    <tbody>
                        {data.data.map((basketBranch, i) => 
                            <TableRow key={basketBranch.branchId} index={i} isNotFromBookshelfOrBasketBuilder={isNotFromBookshelfOrBasketBuilder} showStockCategories={data.showStockCategories} basketBranch={basketBranch} ediOptions={data.ediOptions} basketOptions={data.basketOptions} ediRequired={data.ediRequired} incrementTier={this.incrementTier.bind(this)} propagate={this.propagate.bind(this)} stockCategories={data.stockCategories} hasAreas={hasAreas} ediOverride={data.ediOverride} basketId={data.basketId} basketStockCohort={data.basketStockCohort} />
                        )}
                    </tbody>
                    <Totals rs={rs} isNotFromBookshelfOrBasketBuilder={isNotFromBookshelfOrBasketBuilder} data={data} getItemServicingTotal={this.props.getItemServicingTotal} />
                </table>
                {data.loading == 'Error' && <p>An error occurred loading some additional data</p>}
                <input id="orderingGridTotalItems" type="hidden" value={data.data.reduce((prev, cur) => prev + Number(cur.quantity), 0)} />
            </form>
        );
    }
}

export default OrderingGrid;